// components/dynamic-tabs.js
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import React, { useState } from 'react';
import { Box, Button, Flex } from 'theme-ui';
import SectionHeader from '../components/section-header';

export default function WorkDistribution() {

    const imageAsset = useStaticQuery(graphql`
    query {
      etaxImage: file(relativePath: { eq: "etax-area.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 850) {
            ...GatsbyImageSharpFluid
          }
        }
      },
      foImage: file(relativePath: { eq: "fo-area.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 850) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }`);


    const tabs = [
        {
            label: 'eTax Division',
            content: (
                <Box>
                    <Img fluid={imageAsset.etaxImage.childImageSharp.fluid} />
                </Box>
            )
        },
        {
            label: 'Fiber Optic Division',
            content: (
                <Box>
                    <Img fluid={imageAsset.foImage.childImageSharp.fluid} />
                </Box>
            )
        }
    ]

    const initialTab = 0;
    const [activeTab, setActiveTab] = useState(initialTab)

    return (<Box>

        <div style={{ maxWidth: 1280, margin: 'auto', marginTop: 100 }}>
            <SectionHeader
                slogan="Work Area Distribution"
                title="We operate on a truly national scale, covering strategic locations across Indonesia's diverse regions"
            />
            <Flex
                as="nav"
                sx={{
                    borderColor: 'muted',
                    gap: 5,
                    justifyContent: 'center'
                }}
            >
                {tabs.map((tab, index) => (
                    <Button
                        key={tab.id || index}
                        onClick={() => setActiveTab(index)}
                        sx={{
                            borderRadius: '10',
                            border: '2px solid',
                            borderColor: 'primary',
                            marginBottom: '-2px',
                            bg: activeTab === index ? 'primary' : 'transparent',
                            color: activeTab === index ? 'white' : 'text',
                            px: 4,
                            py: 2,
                            fontSize: 2,
                            fontWeight: activeTab === index ? 'bold' : 'normal',
                            '&:hover': {
                                bg: activeTab === index ? 'primary' : 'muted'
                            }
                        }}
                    >
                        {tab.label}
                    </Button>
                ))}
            </Flex>

            {/* Tab Content */}
            <Box
                sx={{
                    p: 4,
                    minHeight: '200px'
                }}
            >
                {tabs[activeTab].content}
            </Box>
        </div>
    </Box>);
}